module.exports = __webpack_public_path__ + "static/media/night08.6d2a7615.jpg";